export default "__VITE_ASSET__BIdZ9YN0__"